import { TableComment } from "../../../../general/src/TableComment";
import { Button, Checkbox, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierTargetRate extends Layout {
    buttonAdd: Button;
    buttonSearch: Button;
    checkboxFriday: Checkbox;
    checkboxMonday: Checkbox;
    checkboxSaturday: Checkbox;
    checkboxSunday: Checkbox;
    checkboxThursday: Checkbox;
    checkboxTuesday: Checkbox;
    checkboxWednesday: Checkbox;
    labelAvailableDays: Label;
    labelTargetLaneRates: Label;
    layoutTableComment: TableComment;
    panelAvailableDays: Panel;
    panelCarrierRate: Panel;
    panelInfoOnly: Panel;
    panelRateSettings: Panel;
    panelTiming: Panel;
    sourceCarrierLaneRate: DataSource;
    sourceCarrierRate: DataSource;
    sourceComments: DataSource;
    tabComments: Tab;
    tableCarrierLaneRates: Table;
    tabsetComments: Tabset;
    textboxCommodity: Textbox;
    textboxCustomer: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxExtraStopPay: Textbox;
    textboxFuelSurchargePay: Textbox;
    textboxLastUsed: Textbox;
    textboxOrderType: Textbox;
    textboxRateNumber: Textbox;
    textboxRevenueCode: Textbox;
    textboxTimesUsed: Textbox;
    textboxTrailerType: Textbox;
}
